import { FormattedMessage } from 'react-intl';
import { InView } from 'react-intersection-observer';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonLink from '../components/UI/ButtonLink';
import JobHistory from '../components/JobHistory';
import Skills from '../components/Skills';
import Summary from '../components/Summary';
import Title from '../components/UI/Title';
import updateUrlInView from '../services/updateUrlInView';
import { renderSpan } from '../services/renderValues';

/**
 * ## Shows the CV
 * - A summary
 * - A list of my skills
 * - A list of my job history
 * @returns
 */
function About() {
  const navigate = useNavigate();

  return (
    <>
      <section className="text-left text-sm-center" id="title">
        <Title level={1} titleSection>
          <FormattedMessage
            id="about.title"
            values={
              {
                span: renderSpan,
              } as Record<string, any>
            }
          />
        </Title>
      </section>
      <main>
        <div className="container">
          <InView
            threshold={0.5}
            id="summary"
            onChange={(inView) => updateUrlInView(navigate, inView, 'summary')}
          >
            <div className="row">
              <Summary />
            </div>
          </InView>

          <hr className="separator" />
          <InView
            threshold={0.5}
            id="skills"
            onChange={(inView) => updateUrlInView(navigate, inView, 'skills')}
          >
            <Skills />
          </InView>

          <hr className="separator" />
          <InView
            threshold={0.5}
            id="job"
            onChange={(inView) => updateUrlInView(navigate, inView, 'job')}
          >
            <JobHistory />
          </InView>

          <br />
          <ButtonLink link="/realisations" icon="btnPortfolio">
            <FormattedMessage id="about.see-personal-projects" />
          </ButtonLink>
        </div>
      </main>
    </>
  );
}

export default About;
